/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAbout_item = {
    readonly description: string | null;
    readonly englishDescription: string | null;
    readonly " $refType": "PdpSharedDescriptionAbout_item";
};
export type PdpSharedDescriptionAbout_item$data = PdpSharedDescriptionAbout_item;
export type PdpSharedDescriptionAbout_item$key = {
    readonly " $data"?: PdpSharedDescriptionAbout_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAbout_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAbout_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "englishDescription",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '0d672d5921d7399b2f459b96a75f8e64';
export default node;
